// Geometry shared across the app-switcher rail and the chrome that must line up
// with it (the status widget's expanded content width, the loading skeleton's
// footprint). Kept in one module so the rail, its skeleton, and the morphing
// status widget derive from a single source of truth and can't silently drift.

// Collapsed rail width. Also the exact size of a collapsed row's icon square
// once the px-2 column padding is subtracted (48 − 2×8 = 32).
export const RAIL_WIDTH = 48;

// Expanded rail width once hover reveals the row labels.
export const RAIL_EXPANDED_WIDTH = 200;

// Horizontal padding on the rail's inner column (Tailwind px-2 = 8px each side).
export const RAIL_COLUMN_PADDING = 8;

// CSS custom property AppSwitcherRail publishes its current layout width to
// (see `layoutWidth` there). The contextual Sidebar's fixed-position
// container reads this to offset itself past the rail — a plain Tailwind
// class can't do it because that width now varies (48px collapsed, 200px
// pinned open) instead of being permanently RAIL_WIDTH. Set on the document
// root rather than passed as a prop so the two components, which are
// siblings in SidebarLayout, stay independently self-contained.
//
// Tailwind's class scanner needs the literal class string in source, so
// Sidebar.tsx's `left-[var(--app-switcher-rail-width,_48px)]` can't
// reference this constant directly — keep that literal in sync with it by
// hand if it's ever renamed.
export const RAIL_WIDTH_CSS_VAR = "--app-switcher-rail-width";

// Duration/easing of the rail's own width transition (see RAIL_TRANSITION in
// AppSwitcherRail.tsx). Sidebar.tsx applies the same pair to its `left`
// transition so the fixed-position contextual sidebar slides in lockstep
// with the rail instead of snapping once RAIL_WIDTH_CSS_VAR changes.
// Tailwind's scanner needs literal class strings, so this can't be
// interpolated into Sidebar.tsx's className — keep the two in sync by hand.
export const RAIL_WIDTH_TRANSITION_MS = 240;
export const RAIL_TRANSITION_EASING = "cubic-bezier(0.22,1,0.36,1)";
